export default __webpack_public_path__ + "static/media/bg-banner-4.beb26657.jpg";